import { labelFromSicoobKey } from '@/_backoffice/_financial/mixins/sicoob_credentials'

export default new Proxy({}, {
  get(_target, key) {
    if (key === 'then' || typeof key === 'symbol') return undefined
    return labelFromSicoobKey(String(key))
  },
})
